export default "__VITE_ASSET__DhKzuL1S__"